var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-49a230a7"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle mb-4" }, "Comments", -1));
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "columns is-mobile" };
const _hoisted_4 = { class: "column" };
const _hoisted_5 = {
    key: 0,
    class: "noneFound ml-4"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "columns is-mobile" };
const _hoisted_8 = { class: "column" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = { class: "columns" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1));
const _hoisted_12 = {
    key: 0,
    class: "column is-narrow"
};
const _hoisted_13 = { class: "column is-narrow" };
const _hoisted_14 = { class: "column is-narrow" };
import { useAsync } from "@/composables/useAsync";
import { doApiAction, uploadFile } from "@/core/api";
import { isNetworkAdmin } from "@/core/session";
import { computed, onMounted, ref } from "vue";
import CommentWidget from "./CommentWidget.vue";
import { STATIC_CONFIG } from "@/core/config";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CommentSection',
    props: {
        getComments: { type: Function },
        addComment: { type: Function },
        getAttachmentViewLink: { type: Function },
        hideNotifyCaseworkerOption: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const comments = useAsync();
        const sortedComments = computed(() => {
            if (comments.status != 'ready')
                return [];
            const sorted = [...comments.data];
            return sorted.sort((a, b) => a.createdAt - b.createdAt);
        });
        onMounted(() => {
            comments.fetch(props.getComments(), "Failed to load comments");
        });
        // Comment creation
        const newCommentText = ref("");
        const attachSectionExpanded = ref(false);
        const newCommentAttachments = ref([]);
        const notifyCaseworker = ref(false);
        const inProgressAction = ref(null);
        const onAddCommentClicked = () => {
            const text = newCommentText.value.trim();
            if (text.length == 0)
                return;
            doApiAction(inProgressAction, "addComment", "Comment added", "Failed to add comment", () => __awaiter(this, void 0, void 0, function* () {
                comments.data.push(yield props.addComment(text, newCommentAttachments.value, notifyCaseworker.value));
                newCommentText.value = "";
                attachSectionExpanded.value = false;
                newCommentAttachments.value = [];
            }));
        };
        const uploadAttachment = (uploadInfo) => {
            doApiAction(inProgressAction, "uploadAttachment", "Attachment uploaded", "Failed to upload attachment", () => __awaiter(this, void 0, void 0, function* () {
                yield uploadFile(uploadInfo.file)
                    .then(doc => newCommentAttachments.value.push(doc))
                    .finally(() => uploadInfo.onDone());
            }));
        };
        const deleteAttachment = (doc) => {
            // TODO: cleanup on backend?
            newCommentAttachments.value = newCommentAttachments.value.filter(d => d.id != doc.id);
        };
        // Attachment viewing
        const viewAttachment = (comment, attachment) => {
            if (!props.getAttachmentViewLink)
                return;
            doApiAction(inProgressAction, "downloadAttachment", null, "Failed to download attachment", () => __awaiter(this, void 0, void 0, function* () {
                const viewLink = yield props.getAttachmentViewLink(comment.id, attachment.id);
                window.open(viewLink);
            }));
        };
        return (_ctx, _cache) => {
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            const _component_FormCheckboxField = _resolveComponent("FormCheckboxField");
            const _component_DocumentUploadWidget = _resolveComponent("DocumentUploadWidget");
            const _component_SaveButton = _resolveComponent("SaveButton");
            return (_openBlock(), _createElementBlock("div", null, [
                _hoisted_1,
                (_unref(comments).status == 'loading')
                    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                    : (_unref(comments).status == 'ready')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedComments.value, (comment) => {
                                        return (_openBlock(), _createBlock(CommentWidget, {
                                            key: comment.id,
                                            comment: comment,
                                            onViewAttachment: ($event) => (viewAttachment(comment, $event))
                                        }, null, 8, ["comment", "onViewAttachment"]));
                                    }), 128)),
                                    (sortedComments.value.length == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No Comments"))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            (_ctx.addComment && (_unref(isNetworkAdmin)() || !_unref(STATIC_CONFIG).SERVICE_ONLY_MODE))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                class: "textarea",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((newCommentText).value = $event)),
                                                disabled: inProgressAction.value == 'addComment'
                                            }, null, 8, _hoisted_9), [
                                                [_vModelText, newCommentText.value]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _hoisted_11,
                                        (_unref(isNetworkAdmin)() && !_ctx.hideNotifyCaseworkerOption)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                _createVNode(_component_FormCheckboxField, {
                                                    class: "p-1",
                                                    boxLabel: "Notify Caseworker",
                                                    modelValue: notifyCaseworker.value,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((notifyCaseworker).value = $event))
                                                }, null, 8, ["modelValue"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_13, [
                                            (attachSectionExpanded.value)
                                                ? (_openBlock(), _createBlock(_component_DocumentUploadWidget, {
                                                    key: 0,
                                                    documents: newCommentAttachments.value,
                                                    onUpload: _cache[2] || (_cache[2] = ($event) => (uploadAttachment($event))),
                                                    onDelete: _cache[3] || (_cache[3] = ($event) => (deleteAttachment($event)))
                                                }, null, 8, ["documents"]))
                                                : (_openBlock(), _createBlock(_component_SaveButton, {
                                                    key: 1,
                                                    icon: "fa-paperclip",
                                                    label: "Attach Files to Comment",
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (attachSectionExpanded.value = true))
                                                }))
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createVNode(_component_SaveButton, {
                                                icon: "fa-envelope",
                                                label: "Add Comment",
                                                action: "addComment",
                                                inProgressAction: inProgressAction.value,
                                                onClick: _cache[5] || (_cache[5] = ($event) => (onAddCommentClicked()))
                                            }, null, 8, ["inProgressAction"])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
